var UpsellTracker={maxUpsells:4,steps:[],getData:function(){return this.steps},track(e){this.steps.push(e)},reachedMaxUpsells(e){return e.length>=this.maxUpsells},getCurrentStep(){return this.steps.length-1}};
//# sourceMappingURL=/s/files/1/0254/5506/7222/t/82/assets/landing_upsell_tracker.js.map?v=1628881447
